import { render } from "./Cookies.vue?vue&type=template&id=f1fe2bec&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=f1fe2bec&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=f1fe2bec&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src915242178/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1fe2bec"]])

export default __exports__